import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Users, Network, TrendingUp, Copy, Check } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AgentOverview() {
  const [data, setData] = useState(null);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    api.get("/agent/overview").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return <div className="text-gray-400">Caricamento…</div>;
  const link = `${window.location.origin}/?ref=${data.user.referral_code}`;

  const copyLink = () => {
    navigator.clipboard.writeText(link);
    setCopied(true);
    toast.success("Link copiato!");
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="space-y-6 fade-slide" data-testid="agent-overview">
      <div>
        <h1 className="text-3xl font-bold text-[#0A0A0A]">Bentornato, {data.user.nome} 👋</h1>
        <p className="text-gray-500 mt-1">Ecco un riepilogo della tua attività questo mese.</p>
      </div>

      <div className="vg-card p-6">
        <p className="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Il tuo link referral</p>
        <div className="flex gap-2 flex-col sm:flex-row">
          <input className="vg-input text-sm font-mono" readOnly value={link} data-testid="overview-referral-link" />
          <button className="vg-btn-primary px-6" onClick={copyLink} data-testid="overview-copy-btn">
            {copied ? <><Check size={18} /> Copiato</> : <><Copy size={18} /> Copia</>}
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <MetricCard
          icon={Users} title="Lead questo mese"
          value={data.lead_count_month} accent="#B40101"
          testid="metric-leads"
        />
        <MetricCard
          icon={Network} title="Agenti nella rete"
          value={data.rete_agenti} accent="#404040"
          testid="metric-network"
          sub={`${data.referral_attivi} attivi`}
        />
        <MetricCard
          icon={TrendingUp} title="Fee maturata"
          value={`€${data.fee_maturata.toFixed(2)}`}
          accent="#10B981"
          testid="metric-fee"
          sub={`Scaglione ${data.percentuale_scaglione}%`}
        />
      </div>

      <div className="vg-card p-6">
        <h3 className="text-lg font-bold text-[#0A0A0A] mb-2">Suggerimenti rapidi</h3>
        <ul className="space-y-2 text-sm text-gray-600">
          <li>• Condividi il tuo link su WhatsApp con proprietari interessati</li>
          <li>• Recluta nuovi agenti per salire di scaglione referral</li>
          <li>• Aggiorna lo stato dei lead non appena prendi contatto</li>
        </ul>
        <div className="mt-4 flex gap-3">
          <Link to="/agent/leads" className="vg-btn-secondary text-sm" data-testid="overview-go-leads">Vai ai lead</Link>
          <Link to="/agent/link" className="vg-btn-secondary text-sm" data-testid="overview-go-link">Mostra QR code</Link>
        </div>
      </div>
    </div>
  );
}

function MetricCard({ icon: Icon, title, value, accent, sub, testid }) {
  return (
    <div className="vg-card p-6" data-testid={testid}>
      <div className="flex items-center justify-between">
        <div className="w-12 h-12 rounded-[12px] flex items-center justify-center" style={{ background: `${accent}15` }}>
          <Icon size={22} color={accent} />
        </div>
      </div>
      <p className="text-xs uppercase tracking-wide text-gray-400 mt-4 font-semibold">{title}</p>
      <p className="text-3xl font-bold text-[#0A0A0A] mt-1" style={{ fontFamily: "Outfit" }}>{value}</p>
      {sub && <p className="text-xs text-gray-500 mt-1">{sub}</p>}
    </div>
  );
}
